import { render } from "./GameDeals.vue?vue&type=template&id=417e348c"
import script from "./GameDeals.vue?vue&type=script&lang=js"
export * from "./GameDeals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__